
<template>
<b-modal
    v-if="workflow"
    ref="modal"
    id="agCopyModal"
    class="agModal"
    :class="{'agModal-loading':isLoading}"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="copyButton_click">
    <template slot="modal-header">
      <h4 class="agModal-title">Copy Workflow</h4>
    </template>
    <div class="agInputGroup">
        <label>Workspace:</label>
        <b-form-select 
          class="agMediumInput"
          v-model="workspace"
          :options="workspaceOptions"
          :disabled="isLoading"
          :state="hasError('workspace')">
        </b-form-select>
    </div>
    <div class="agInputGroup">
        <label>Name:</label>
        <b-input
          class="agMediumInput"
          v-model="name"
          :disabled="isLoading"
          :state="hasError('name')">
        </b-input>
    </div>
    <div v-if="modalMessage">
      <hr>
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-spinner v-if="isLoading" class="agModal-loadingSpinner"></b-spinner>
      <b-button class="agModal-buttonRight" variant="primary" :disabled="isLoading" @click="copyButton_click">Copy</b-button>
    </template>
  </b-modal>
</template>






<script>

// components


// modules
import Server from "src/server";


export default {
    name: "ag-copy-modal",

    components: {

    },

    props:{
        workflow: Object,
    },

    data(){
        return {
            isLoading: false,
            modalMessage: "",
            modalMessageClass: "",
            errorField: "",
            workspace: "",
            workspaceOptions: [],
            name: "",
            workflows: [],
        };
    },

    computed: {

        workspaces() {
            return this.$store.getters["wsStore/userWorkspaces"];
        },
    },
    
    watch: {
      async workspace() {
          this.workflows = [];

          if(this.workspace) {
            try {
                var result = await Server.post("getWorkflows", { workspace: this.workspace }).promise;
                if(!result.data.success)
                    throw(result.data.error);

                this.workflows = result.data.workflows;
            }
            catch(e) {
                console.log("Failed 'getWorkflows' server call. " + e.toString());
             }
          }
      }
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events

        
        async copyButton_click() {

            if(!this.validate()) {
                return;
            }

            this.workflow.name = this.name;

            this.isLoading = true;
            var result = await this.$store.dispatch("wfStore/copyWorkflow", {workflow: this.workflow, workspace: this.workspace});
            this.isLoading = false;
            if(result.data.success) {
                this.hide();
                this.$emit("reloadWorkflows");
            }
            else {
                this.modalMessage = "Failed to copy workflow. " + result.data.error;
                this.modalMessageClass = "agModal-errorMessage";
            }
          
        },

        // emitted Events


        // other

        show() {
            setTimeout(() => {
                this.reset();
                this.$refs.modal.show();
            }, 250);
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          this.modalMessage = "";
          this.modalMessageClass = "";
          this.errorField = "";
          this.workspace = "";
          this.name = "";
          this.setWorkspaceOptions();
        },

        hasError(field) {
            if (field == this.errorField) {
                return false; // false = error
            }
            return null;
        },

        validate()
        {
            this.modalMessage = "";
            this.modalMessageClass = "";
            this.errorField = "";

            if(!this.workspace) {
                this.modalMessage = "A workspace must be selected";
                this.modalMessageClass = "agModal-errorMessage";
                this.errorField = "workspace";
                return false;
            }
            if(!this.name) {
                this.modalMessage = "The copy must be named";
                this.modalMessageClass = "agModal-errorMessage";
                this.errorField = "name";
                return false;
            }

            return true;
        },

        setWorkspaceOptions() {
            this.workspaceOptions = [];
            for(var i = 0; i < this.workspaces.length; i++) {
                var workspace = this.workspaces[i];
                this.workspaceOptions.push({value: workspace._id, text: workspace.name});
            }
        },
    }
}

</script>






<style scoped lang="css">


</style>



// WEBPACK FOOTER //
// src/components/workflow/CopyModal.vue